import * as React from 'react';

import { getTermValue } from '../../../../../JsonQuery';
import { ESuburbanOfferFilter } from '../../../../../api-models/common/json_query';
import { Posessor } from '../../../components/filters/Posessor';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const PosessorContainer: React.FC = () => {
  const { jsonQuery, onChange, onApply } = useFiltersContext();
  const posessorType = getTermValue('suburban_offer_filter')(jsonQuery);

  const handleChange = React.useCallback(
    (posessorType: ESuburbanOfferFilter | null) => {
      onChange({ action: 'setPosessor', arguments: [posessorType] });
      onApply();
    },
    [onChange, onApply],
  );

  return <Posessor value={posessorType} onChange={handleChange} />;
};
